import React from 'react';
import { message } from 'antd';

import { confirm } from './index';
import sceneActions from '../../../actions/sceneActions';
import recordActions from '../../../actions/recordActions';
import AppState from '../../../appState';

// eslint-disable-next-line default-param-last
export default function closeRecordConfirmation({sceneId, callback, confirmProps = {}, t}) {
  const { text, headerText, saveText, abortText, cancelText } = confirmProps;
  
  function onSave(saveCallback) {    
    const sceneParams = AppState.getIn(["scenes", sceneId, "params"]);
    const catalogId = sceneParams && sceneParams.get("catalogId");
    const recordId = sceneParams && sceneParams.get("recordId");

    recordActions.validateAndSaveRecord(
      {
        catalogId,
        recordId,
      },
      {
        sceneId,
      },
      (result) => {
        saveCallback && saveCallback();
        callback && callback(true);
      },
      (error) => {
        error && message.error(error.message || error);
        saveCallback && saveCallback();
        onCancel();
      },
    )
  }

  function onAbort() {
    callback && callback(true);
  }

  function onCancel() {
    sceneActions.cancelDeleteScene();
    callback && callback(false);
  }

  confirm({
    onSave,
    onAbort,
    onCancel,
    headerText: headerText || t('modals.closeEditor.headerText'),
    text: (
      <span
        dangerouslySetInnerHTML={{
          __html: text || t('modals.closeEditor.text'),
        }}
      />
    ),
    saveText: saveText !== undefined ? saveText : t('modals.closeEditor.saveText'),
    abortText: abortText  !== undefined ? abortText :  t('modals.closeEditor.abortText'),
    cancelText: cancelText  !== undefined ? cancelText :  t('modals.closeEditor.cancelText'),
  });
}
